<template>
    <div>
      <Modal v-model="modal" title="Eway Bill Number" draggable>
        <p style="margin-bottom: 15px">Order No.: {{order?order.orderNumber:''}}</p>

        <Form>
          <FormItem label="Eway Bill No.">
            <Input v-model="ewayBillNo"/>
          </FormItem>
          <FormItem label="Is Eway Bill Verified">
            <i-switch v-model="isEwayBillVerified" size="large">
              <span slot="open">ON</span><span slot="close">OFF</span>
            </i-switch>
          </FormItem>
        </Form>

        <div slot="footer">
          <Button type="primary" style="font-weight: bolder" @click="addEwayBillDetails()" :disabled="!ewayBillNo" :loading="loader1">
            <span v-if="!loader1">Save</span>
            <span v-else>Loading...</span>
          </Button>
          <Button style="background: #999999; color: white;font-weight: bolder" @click="closeModal()">Cancel</Button>
        </div>
      </Modal>

     <!--   <div v-if="isEditor && isVisible" :style="style" style="width: 350px;"
             id="colorPickerElement" @mousedown="stopMousedownPropagation">

            <p style="margin-bottom: 15px">Order No.: {{order.orderNumber}}</p>

             <Form>
                <FormItem label="Eway Bill No.">
                <Input v-model="ewayBillNo"/>
                </FormItem>

                 <FormItem label="Is Eway Bill Verified">
                 <i-switch v-model="isEwayBillVerified" size="large">
                    <span slot="open">ON</span><span slot="close">OFF</span>
                </i-switch>
                 </FormItem>
                <div style="float: right">
                    <Button @click="addEwayBillDetails()" :disabled="!ewayBillNo" :loading="loader1">
                        <span v-if="!loader1">Save</span>
                        <span v-else>Loading...</span>
                    </Button>
                    <Button style="margin-left: 10px" @click="close()">Cancel</Button>
                </div>
             </Form>
        </div>  -->

<!--        <div v-if="isRenderer" style="text-align: center">-->
<!--            <span :class="$parent.$parent.$parent.orders[row]&&$parent.$parent.$parent.orders[row].orderDetails&&-->
<!--                          $parent.$parent.$parent.orders[row].orderDetails.isEwayBillVerified?'green-text':'red-text'">-->
<!--                {{value}}</span>-->
<!--        </div>-->

    </div>
</template>

<script>
    import {BaseEditorComponent} from '@handsontable/vue'
    import {Constants} from "../../Constants/Constant"
    import {generate_UPDATE_ORDER_DATA} from "../../graphql/mutations/orders"

    export default {
        name: "EwayBillPopup",
        extends: BaseEditorComponent,
        data:function () {
            return{
                Constants: Constants,
                modal: false,
                order: null,
                hotInstance: null,
                TD: null,
                row: null,
                col: null,
                prop: null,
                originalValue: null,
                value: '',
                cellProperties: null,
                isVisible: false,
                isEditor: null,
                isRenderer: null,
                editorElement: null,
                style: {
                    position: "absolute",
                    padding: "15px",
                    background: "#fff",
                    zIndex: 999,
                    border: "1px solid #000",
                    right: "0px",
                    top: "0px"
                },
                loader1: false,
                ewayBillNo: '',
                isEwayBillVerified: false,
            }
        },
        methods:{
            stopMousedownPropagation: function(e) {
                e.stopPropagation();
            },
            prepare: function(row, col, prop, td, originalValue, cellProperties) {
                BaseEditorComponent.options.methods.prepare.call(this, row, col, prop, td, originalValue, cellProperties);
                const tdPosition = td.getBoundingClientRect();
                // this.style.left = tdPosition.left + window.pageXOffset + 'px';
                this.style.right = (window.innerWidth - tdPosition.right) + 'px';
                this.style.top = tdPosition.top + window.pageYOffset + 'px';
            },
            open: function() {
              let screen = this.$parent.$parent.$parent.screen
              let ordersVariable = screen + '_orders'
              let pRow = this.hotInstance.toPhysicalRow(this.row)                             //When accessing original array
              this.order = this.$parent.$parent.$parent[ordersVariable][pRow]


                this.ewayBillNo = this.order.orderDetails.ewayBillNo
                this.isEwayBillVerified = this.order.orderDetails.isEwayBillVerified?this.order.orderDetails.isEwayBillVerified:false

                this.isVisible = true
                this.modal = true
            },
            focus: function() {
                this.isVisible = true;
            },
            close: function() {
              this.isVisible = false;
            },
            setValue: function(value) {
                this.value = value;
            },
            getValue: function() {
                return this.value;
            },
            closeModal(){
              this.modal = false
            },
            addEwayBillDetails(){
                let obj = { ewayBillNo: this.ewayBillNo, isEwayBillVerified: this.isEwayBillVerified }
                this.updateRecord(this.order.orderDetails.id, obj, 'orderDetails', 'loader1')
            },
            async updateRecord(id, obj, table, loaderStr){
                this[loaderStr] = true
                let response = await this.$apollo.mutate({
                    mutation: generate_UPDATE_ORDER_DATA(table),
                    variables: { id: id, obj: obj}
                })
                if(response.data){
                    this.$Message.success('Order updated successfully!')
                    this[loaderStr] = false
                    this.close()
                    this.closeModal()
                    this.finishEditing()
                }
            },
        },
    }
</script>

<style scoped>
    .green-text{
        color: green;
    }
    .red-text{
        color: red;
    }
</style>
